/**
 * Returns stop ids in left-to-right order by position.
 */
export function getInitialOrderFromStops(stops) {
  return [...stops].sort((a, b) => a.position - b.position).map((s) => s.id);
}
